import type { Message } from '../../../services/chatService/ChatService';

export const isImageAttachment = (message: Message): boolean =>
    Boolean(message.attachmentContentType?.startsWith('image/') || message.attachmentType?.startsWith('image'));

export const getAttachmentDisplayName = (message: Message): string =>
    message.attachmentOriginalName || 'Attachment';
